import React, { FC } from 'react'
import s from './Employment.module.css'
import { CoopCompaniesData } from '../../store/modules'
import { mediaUrl } from '../../reused';

interface EmployeeCardProps {
    item: CoopCompaniesData
}

const EmployeeCard: FC<EmployeeCardProps> = ({ item }) => {
    const { image } = item
    return (
        <div className={s.employersCard}>
            <img src={mediaUrl(image)} alt="VK" />
        </div>
    )
}

export default EmployeeCard